<template>
  <div class="form-group">
    <textarea v-model.lazy="featureProduct.feature_value" class="form-control "/>
  </div>
</template>

<script>
export default {
  name: "FeatureInputTextArea",
  props: {
    featureProduct: {},
    product: {},
  },
}
</script>


<style scoped>

</style>